// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__spinner-knMMX","spinner-ripple":"spinner__spinner-ripple-gG0Oc","small":"spinner__small-Hj_Xu","medium":"spinner__medium-VVd1j","large":"spinner__large-QGE1C"};